import { existsSync } from 'node:fs';
import { getSetupFile } from './getSetupFile';

export const exists = () => {
  const path = getSetupFile();
  const check = existsSync(path);

  return { check, path };
};
